import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ComponentSync, LL_V_L, TS_Checkbox } from '@nu-art/thunderstorm-frontend/index';
import './Renderer_PathwayItemChildSelector.scss';
import { ModuleFE_Pathway } from '../../../_entity/pathway/index.js';
export class Renderer_PathwayItemChildSelector extends ComponentSync {
    deriveStateFromProps(nextProps, state) {
        state = super.deriveStateFromProps(nextProps, state);
        state.pathwayId = nextProps.pathwayId;
        state.selectedPathwayIds ??= [];
        state.children = ModuleFE_Pathway.getChildren(state.pathwayId);
        return state;
    }
    render() {
        if (!this.state.children.length)
            return;
        return _jsxs(LL_V_L, { className: 'pathway-item__child-selector', children: [_jsx("div", { children: "Select children to apply changes:" }), this.state.children.map(child => _jsx(TS_Checkbox, { checked: this.state.selectedPathwayIds.includes(child._id), disabled: !this.props.childFilter(child), onCheck: checked => {
                        if (checked)
                            return this.setState({ selectedPathwayIds: [...this.state.selectedPathwayIds, child._id] }, () => this.props.onChangeCallback(this.state.selectedPathwayIds));
                        return this.setState({ selectedPathwayIds: this.state.selectedPathwayIds.filter(id => id !== child._id) }, () => this.props.onChangeCallback(this.state.selectedPathwayIds));
                    }, children: child.label }, child._id))] });
    }
}
//# sourceMappingURL=Renderer_PathwayItemChildSelector.js.map